import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'
import { useMemo } from 'react'
import { FinancingConfigDto } from './../../node_modules/@applyonline/shared/types/FinancingConfigApi'

/** A merchant config of 0 would leave the lower bound vacuous, and a zero amount crashes the credit api. */
export function getMinimumLoanAmount(financingProrgamConfig: FinancingConfigDto) {
  return Math.max(1, financingProrgamConfig.minimumLoanAmount)
}

function buildWorksheetSchema(
  availableCredit: number,
  amountRequested: number,
  term: number,
  financingProrgamConfig: FinancingConfigDto,
) {
  const minimumLoanAmount = getMinimumLoanAmount(financingProrgamConfig)

  return yup.object({
    amountRequested: yup
      .double()
      .required()
      .default(amountRequested)
      .min(minimumLoanAmount, () => t('worksheet.error.between', { min: minimumLoanAmount, max: availableCredit }))
      .max(availableCredit, () => t('worksheet.error.between', { min: minimumLoanAmount, max: availableCredit })),
    term: yup.integer().required().default(term),
    firstPaymentOn: yup.string().dateOnly().validDate().required(),
    includeInsurance: yup.boolean().required(),
  })
}
export function useWorksheetSchema(
  availableCredit: number,
  amountRequested: number,
  term: number,
  financingProrgamConfig: FinancingConfigDto,
) {
  return useMemo(
    () => buildWorksheetSchema(availableCredit, amountRequested, term, financingProrgamConfig),
    [availableCredit, amountRequested, term, financingProrgamConfig],
  )
}

export type WorksheetForm = yup.InferSubmit<ReturnType<typeof buildWorksheetSchema>>
